<template>
  <el-dialog v-model="visibleDialog" :visible.sync="visibleDialog" @close="visibleDialog=false">
    <div class="result-box">
      <div class="tts"><img src="@/assets/images/m6.png" @click="visibleDialog=false"/></div>
      <div class="input-box">
        <div class="box-box">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="textarea"
            maxlength="800"
            show-word-limit
          >
          </el-input>
        </div>
        <div class="input-bottom">
          <div class="input-bt"><img src="@/assets/images/m4.png"/>发送至飞行员</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    visibleDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
  },
  data() {
    return {textarea: ''}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.tts {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
  padding-top: 20px;

  img {
    width: 20px;
    cursor: pointer;
  }
}

.input-box {
  padding: 12px 20px 28px 20px;

  .input-bottom {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 8px;

    img {
      width: 20px;
      cursor: pointer;
      margin-right: 16px;
      cursor: pointer;
    }

    .input-bt {
      border-radius: 4px;
      background: #AFC6F5;
      height: 26px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1656D7;
      font-size: 14px;
      cursor: pointer;

      img {
        margin-right: 4px;
        width: 12px;
      }
    }
  }

  .box-box {
    padding: 12px;
    margin-bottom: 12px;
  }

  /deep/ .el-input__count {
    background: transparent;
    top: -44px;
    left: 0px;
    right: initial;
  }

  /deep/ .el-textarea__inner {
    background: transparent !important;
    border: none;
    resize: none;
    height: 655px !important;
    font-size: 16px;
    line-height: 24px;
    padding: 0;
  }
}

/deep/ .el-dialog {
  margin: 0 !important;
  box-shadow: 0px 23px 33px rgba(18, 21, 30, 0.794744);
  border-radius: 12px;
  border: 1px solid #1C2539;
  background: #262D40;
  width: 608px;
  height: 785px;
  position: absolute;
  right: 24px;

  .el-dialog__header {
    padding: 0;
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/summarize/resulttextModal.vue